/* © NXAPP Limited */
import { cn } from '@/lib/utils'

const STATUS_STYLES: Record<string, string> = {
  SUBSCRIBED: 'bg-green-100 text-green-700',
  UNSUBSCRIBED: 'bg-gray-100 text-gray-600',
  BOUNCED: 'bg-red-100 text-red-700',
  COMPLAINED: 'bg-orange-100 text-orange-700',
  DRAFT: 'bg-gray-100 text-gray-600',
  PENDING_APPROVAL: 'bg-yellow-100 text-yellow-700',
  APPROVED: 'bg-blue-100 text-blue-700',
  SCHEDULED: 'bg-indigo-100 text-indigo-700',
  SENDING: 'bg-purple-100 text-purple-700',
  SENT: 'bg-green-100 text-green-700',
  FAILED: 'bg-red-100 text-red-700',
  // AI failsafe variants (keyed by synthetic status)
  SCHEDULED_AI: 'bg-indigo-100 text-indigo-700 ring-1 ring-indigo-300',
  SENT_AI: 'bg-green-100 text-green-700 ring-1 ring-green-300',
}

/**
 * `status` is the raw issue status. Pass `label` to show custom text (e.g.
 * "Scheduled by AI") while `variant` picks the colour scheme.
 */
export default function StatusBadge({
  status,
  label,
  variant,
}: {
  status: string
  label?: string
  variant?: string
}) {
  const key = variant ?? status
  return (
    <span className={cn('badge', STATUS_STYLES[key] ?? 'bg-gray-100 text-gray-600')}>
      {label ?? status.replace(/_/g, ' ')}
    </span>
  )
}
